import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const saveGrantParameters = async (outorgaId, payload) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/condicao/parametro/bulk/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.post(requestURL, payload, config)
        return response
    } catch (error) {
        console.error(
            'Erro ao salvar os parâmetros da condição de outorga: ',
            error
        )
        return {}
    }
}

const deleteGrantParameter = async (outorgaId, paramId) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/condicao/parametro/${paramId}/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const { status } = await axios.delete(requestURL, config)
        return status
    } catch (error) {
        console.error(
            'Erro ao deletar o parâmetro da condição de outorga: ',
            error
        )
        return {}
    }
}

const getGrantParameters = async (outorgaId) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/condicao/parametro/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        return response
    } catch (error) {
        console.error(
            'Erro ao buscar os parâmetros da condição de outorga: ',
            error
        )
        return {}
    }
}

const saveGrantSchedule = async (outorgaId, payload) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/cronograma/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.post(requestURL, payload, config)
        return response
    } catch (error) {
        console.error(
            'Erro ao salvar o cronograma de outorga: ',
            error
        )
        return {}
    }
}

const getGrantChartsParameters = async (outorgaId) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/parametro/tipo/grafico/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        return response
    } catch (error) {
        console.error(
            'Erro ao buscar os parâmetros da outorga: ',
            error
        )
        return {}
    }
}

const saveGrantCharts = async (outorgaId, payload) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/parametro/grafico/bulk/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.post(requestURL, payload, config)
        return response
    } catch (error) {
        console.error(
            'Erro ao salvar os gráficos da outorga: ',
            error
        )
        return {}
    }
}

const getGrantCharts = async (outorgaId) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/parametro/grafico/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        return response
    } catch (error) {
        console.error(
            'Erro ao buscar os gráficos da outorga: ',
            error
        )
        return {}
    }
}

const deleteGrantCharts = async (outorgaId, graficoId) => {
    const userInfo = auth.getUserInfo()

    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/ambiental/outorga/${outorgaId}/parametro/grafico/${graficoId}/`

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const { status } = await axios.delete(requestURL, config)
        return status
    } catch (error) {
        console.error(
            'Erro ao deletar o gráfico de outorga: ',
            error
        )
        return {}
    }
}

const getGrantList = async (state = {}) => {
    const userInfo = auth.getUserInfo()

    let requestURL = `${cfg.base_api_url + cfg.api_v2}/${userInfo.empresa}/ambiental/outorga/?limit=${state?.lineCount || 10}${state.filter || ''}`

    if (state?.url) {
        requestURL = state.url
    }

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    try {
        const response = await axios.get(requestURL, config)
        const data = response.data

        return {
            grantList: data.results || data,
            count: data.count || (data.results ? data.results.length : data.length),
            next: data.next || null,
            previous: data.previous || null
        }
    } catch (error) {
        console.error('Erro ao buscar lista de outorgas: ', error)
        return {
            grantList: [],
            count: 0,
            next: null,
            previous: null
        }
    }
}

export {
    saveGrantParameters,
    deleteGrantParameter,
    getGrantParameters,
    saveGrantSchedule,
    getGrantChartsParameters,
    saveGrantCharts,
    getGrantCharts,
    deleteGrantCharts,
    getGrantList,
}
